var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ERROR_CODE, VIDEO_NODE_EVENT, VIDEO_STATE } from '../enums';
import { i18nConfig } from '../i18n';
import EvtEmitter from '../libs/event-emitter';
import { t } from '../util';
var CheckHealth = /** @class */ (function (_super) {
    __extends(CheckHealth, _super);
    function CheckHealth(vn) {
        var _this = _super.call(this) || this;
        /** 记录当前状态的开始时间戳 */
        _this.stateStartTimeStamp = 0;
        /** 上一帧的播放时间点 */
        _this.preFramePlaytime = 0;
        /** 已经在playtime无变化时停滞的帧数 */
        _this.playtimeStalledFrameCount = 0;
        _this.videoNode = vn;
        _this.setVideoNodeEvts(true);
        return _this;
    }
    /**
     * 循环调用此函数来检查播放健康情况
     */
    CheckHealth.prototype.loop = function () {
        var curTimeStamp = +new Date();
        // 检查状态变化和检查时间变化的逻辑是分开的。实际上这两个逻辑是类似的，都是在某个状态下播放进度长时间停滞。但是分开的原因是在直播的场景下
        // 发现hls.js内核会停留在seeking状态并且不断seek，此时播放进度是不断变化的
        // 因此无法将每个状态的停滞逻辑基于播放进度停滞来编写，而是状态停滞用一个函数，播放进度停滞用一个函数。
        this.checkStateStalled(curTimeStamp);
        this.checkPlaytimeStalled();
    };
    CheckHealth.prototype.destroy = function () {
        this.setVideoNodeEvts(false);
        this.removeAllListeners();
        this.stateStartTimeStamp = 0;
        this.videoNode = null;
        this.videoNodeEvtMap = null;
        this.preFramePlaytime = 0;
        this.playtimeStalledFrameCount = 0;
    };
    CheckHealth.prototype.setVideoNodeEvts = function (value) {
        var _a;
        var _this = this;
        if (!this.videoNode) {
            return;
        }
        if (!this.videoNodeEvtMap) {
            this.videoNodeEvtMap = (_a = {},
                _a[VIDEO_NODE_EVENT.STATE_CHANGE] = this.videoNodeStateChange.bind(this),
                _a);
        }
        Object.keys(this.videoNodeEvtMap).forEach(function (key) {
            if (value) {
                _this.videoNode.on(key, _this.videoNodeEvtMap[key]);
            }
            else {
                _this.videoNode.off(key, _this.videoNodeEvtMap[key]);
            }
        });
    };
    CheckHealth.prototype.videoNodeStateChange = function () {
        // 设置每个状态扭转时的起始时间戳
        this.stateStartTimeStamp = +new Date();
    };
    /**
     * 检查是否在某些状态下长时间停滞
     */
    CheckHealth.prototype.checkStateStalled = function (curTimeStamp) {
        var _a = this.videoNode, config = _a.config, state = _a.state;
        if ([VIDEO_STATE.BUFFERING, VIDEO_STATE.SEEKING].indexOf(state) === -1) {
            // 只检查这些状态的停滞
            return;
        }
        if (this.stateStartTimeStamp <= 0 || config.maxStateStalledTime <= 0) {
            return;
        }
        if (curTimeStamp - this.stateStartTimeStamp > config.maxStateStalledTime) {
            // 重试前把当前状态的开始时间戳重置。因为重试过程中状态可能无变化（例如一直是buffering状态），重置后可避免重复的重试。
            this.stateStartTimeStamp = 0;
            this.emit(HEALTH_EVTS.STATE_STUCK, {
                code: ERROR_CODE.STATE_STUCK,
                message: t(i18nConfig.core.ERROR_PLAY_STUCK),
                state: state,
            });
        }
    };
    /**
   * 检查在playing状态下playtime是否长时间停滞
   */
    CheckHealth.prototype.checkPlaytimeStalled = function () {
        var _a = this.videoNode, config = _a.config, state = _a.state, videoElement = _a.videoElement;
        if (state !== VIDEO_STATE.PLAYING
            || videoElement.duration <= 0
            // currentTime <= 0条件摘自老播放器，说明如下：
            // 某些浏览器在直播时不会发出timeupdate事件，不会更新currentTime的值，这里要避免为0的情况
            || videoElement.currentTime <= 0
            || config.maxPlaytimeStalledTime <= 0) {
            return;
        }
        if (this.preFramePlaytime > 0) {
            if (this.preFramePlaytime !== videoElement.currentTime) {
                // 只要播放进度有变化，就重置停滞的帧数
                this.playtimeStalledFrameCount = 0;
            }
            else {
                // 否则开始检查停滞的时长
                this.playtimeStalledFrameCount++;
                if (this.playtimeStalledFrameCount * 16.7 > config.maxPlaytimeStalledTime) {
                    this.playtimeStalledFrameCount = 0;
                    this.emit(HEALTH_EVTS.PLAYTIME_STUCK, {
                        code: ERROR_CODE.ORG_PLAY_STUCK_ERR,
                        message: t(i18nConfig.core.ERROR_PLAY_STUCK),
                        state: state,
                    });
                }
            }
        }
        this.preFramePlaytime = videoElement.currentTime;
    };
    return CheckHealth;
}(EvtEmitter));
export { CheckHealth };
// eslint-disable-next-line @typescript-eslint/naming-convention
export var HEALTH_EVTS;
(function (HEALTH_EVTS) {
    HEALTH_EVTS["STATE_STUCK"] = "state-stuck";
    HEALTH_EVTS["PLAYTIME_STUCK"] = "playtime-stuck";
})(HEALTH_EVTS || (HEALTH_EVTS = {}));
;
